/* DEPENDENCIES */
const bsn = require('bootstrap.native');
const _ = require('underscore');
import '@fortawesome/fontawesome-free/js/all';

/* IMPORTS */
const manifest = require('../projects/config.json');
// noinspection JSFileReferences
import * as projectStaticImages from 'url:../assets/images/*.{jpg,jpeg,png,svg,webp,mp4,webm}';
// noinspection JSFileReferences
import * as slideStaticImages from 'url:../assets/images/slideshows/*.{jpg,jpeg,png,svg,webp}';

function init() {
    _.each(manifest.projects, function(project) {
        /*** TAB PANE CREATION ***/
        let tabPanes = document.getElementById('tab-panes');

        let tabPane = document.createElement('div');

        tabPane.setAttribute('id', 'p-' + project.id);
        tabPane.setAttribute('role', "tabpanel");
        tabPane.setAttribute('aria-labelledby', "p-" + project.id + '-tab');
        tabPane.classList.add('tab-pane');
        tabPane.classList.add('fade');

        // CONTAINER
        let container = document.createElement('div');

        container.classList.add('container-lg');
        container.classList.add('mt-2');

        if (project.id === "sarkamist-github-io") {
            let about = document.getElementById('about');
            about.insertBefore(container, about.firstChild)
        } else { tabPane.appendChild(container); }

        // JUMBOTRON
        let jumbotron = document.createElement('div');

        jumbotron.classList.add('h-100', 'p-5', 'bg-light', 'border', 'rounded-3');

        container.appendChild(jumbotron);

        // TITLE
        let title = document.createElement('h1');

        title.classList.add('display-5');
        title.innerHTML = project.name;

        jumbotron.appendChild(title);

        // DESCRIPTION BLOCK
        let descriptionBlock = document.createElement('div')

        descriptionBlock.classList.add('row')
        descriptionBlock.classList.add('row-cols-md-1')
        descriptionBlock.classList.add('row-cols-lg-2')

        jumbotron.appendChild(descriptionBlock)

        // TEXT COLUMN
        let descriptionTextColumn = document.createElement('div')

        descriptionTextColumn.classList.add('col-7')

        descriptionBlock.appendChild(descriptionTextColumn)

        // DESCRIPTION
        let description = document.createElement('p');

        description.classList.add('lead');
        description.classList.add('lead');
        description.innerHTML = project.description;

        descriptionTextColumn.appendChild(description);

        // DETAILS COLUMN
        let descriptionDetailsColumn = document.createElement('div')

        descriptionDetailsColumn.classList.add('col-5')

        descriptionBlock.appendChild(descriptionDetailsColumn)


        // IMAGE
        let image = createProjectMedia(projectStaticImages, project.img, project.shortname);

        image.classList.add('img-thumbnail');

        if (project.id !== "sarkamist-github-io") descriptionDetailsColumn.appendChild(image);

        // SEPARATOR
        let separator = document.createElement('hr');

        separator.classList.add('my-4');

        if (project.id !== "sarkamist-github-io") descriptionDetailsColumn.appendChild(separator);

        // STACK CARD
        let stackCard = document.createElement('div')

        stackCard.classList.add('card')

        descriptionDetailsColumn.appendChild(stackCard)

        // STACK LIST

        let stackList = document.createElement('ul')

        stackList.classList.add('list-group')
        stackList.classList.add('list-group-flush')

        stackCard.appendChild(stackList)

        // STATUS CONTAINER
        let statusContainer = document.createElement('li');

        statusContainer.classList.add('list-group-item');
        statusContainer.classList.add('text-center');
        statusContainer.classList.add('fs-4');

        // STATUS
        _.each(project.state, function(status) {
            let badge = document.createElement('span');

            badge.classList.add('badge');
            badge.classList.add('badge-lg');
            badge.classList.add('badge-dark');
            badge.classList.add('m-1');
            if (manifest.statuses[status]){
                let conf = manifest.statuses[status];
                if (conf.background) {
                    badge.style.background = conf.background;
                } else {
                    badge.style.backgroundColor = conf.color;
                }
                badge.style.color = conf.font_color;
                badge.innerHTML = (conf.fa_icon)? conf.fa_icon + '&nbsp;' + conf.name : conf.name;
            } else {
                badge.innerHTML = status;
            }

            statusContainer.appendChild(badge);
        });

        stackList.appendChild(statusContainer);

        // BADGE CONTAINER
        let badgeContainer = document.createElement('li');

        badgeContainer.classList.add('list-group-item');
        badgeContainer.classList.add('text-center');
        badgeContainer.classList.add('fs-4');

        // BADGES
        _.each(project.tags, function(tag) {
            let conf = manifest.technologies[tag];
            let badge = document.createElement(conf.url ? 'a' : 'span');

            badge.classList.add('badge');
            badge.classList.add('badge-lg');
            badge.classList.add('badge-dark');
            badge.classList.add('m-1');
            if (conf){
                if (conf.background) {
                    badge.style.background = conf.background;
                } else {
                    badge.style.backgroundColor = conf.color;
                }

                if (conf.outline) {
                    badge.style.outlineOffset = "-0.125em";
                    badge.style.outline = conf.outline;
                }

                if (conf.url) {
                    badge.setAttribute('href', conf.url)
                }

                badge.style.color = conf.font_color;
                badge.innerHTML = (conf.fa_icon) ? conf.fa_icon : '';
                badge.innerHTML += (conf.name) ? (conf.fa_icon) ? '&nbsp' + conf.name : conf.name : '';
            } else {
                badge.innerHTML = tag;
            }

            badgeContainer.appendChild(badge);
        });

        stackList.appendChild(badgeContainer);

        if (project.url || project.repositories) {
            // SEPARATOR
            let separator = document.createElement('hr');

            separator.classList.add('my-4');

            if (project.id !== "sarkamist-github-io") descriptionDetailsColumn.appendChild(separator);

            // ACTION PANE
            let actions = document.createElement('p');
            actions.classList.add('text-center');

            descriptionDetailsColumn.appendChild(actions);

            // ACTIONS
            // Visit
            if (project.url) {
                let action_url = document.createElement('a');
                action_url.setAttribute('id', 'p-' + project.id + '-visit-button');

                action_url.classList.add('btn');
                action_url.classList.add('btn-lg');
                action_url.classList.add('btn-dark');
                action_url.classList.add('f-inconsolata');
                action_url.classList.add('m-1');
                action_url.setAttribute('href', project.url);
                action_url.setAttribute('role', 'button');
                action_url.innerHTML = '<i class="fa-solid fa-arrow-up-right-from-square"></i>&nbsp;Visit';

                actions.appendChild(action_url);
            }

            // Repositories
            if (project.repositories) {
                _.each(project.repositories, function (repository) {
                    let action_url = document.createElement('a');
                    action_url.setAttribute('id', 'p-' + project.id + '-repository-button');

                    action_url.classList.add('btn');
                    action_url.classList.add('btn-lg');
                    action_url.classList.add('btn-dark');
                    action_url.classList.add('f-inconsolata');
                    action_url.classList.add('m-1');
                    action_url.setAttribute('href', repository);
                    action_url.setAttribute('role', 'button');
                    let text;
                    if (repository.startsWith("https://github.com")) {
                        text = '<i class="fa-brands fa-xl fa-github"></i>&nbsp;Github';
                    } else if (repository.startsWith("https://sarkamist.itch.io")) {
                        text = '<i class="fa-brands fa-xl fa-itch-io"></i>&nbsp;itch.io';
                    } else {
                        text = '<i class="fa-solid fa-code"></i>&nbsp;Source';
                    }
                    action_url.innerHTML = text;

                    actions.appendChild(action_url);
                });
            }
        }

        //SLIDESHOW
        if (project.slideshow) {
            // SEPARATOR
            let separator = document.createElement('hr');

            separator.classList.add('my-4');

            jumbotron.appendChild(separator);

            // Slideshow Block
            let slideshowBlock = document.createElement('div')

            slideshowBlock.classList.add('row');
            slideshowBlock.classList.add('mt-4');
            slideshowBlock.innerHTML = '<h1 class="display-6 text-muted text-center">Gallery</h1>';

            jumbotron.appendChild(slideshowBlock);

            // Slideshow
            let slideshow = document.createElement('div')

            slideshow.setAttribute('id', `slideshow-${project.id}`)
            slideshow.setAttribute('data-bs-ride', 'carousel');
            slideshow.classList.add('carousel');
            slideshow.classList.add('carousel-dark');
            slideshow.classList.add('slide');


            slideshowBlock.appendChild(slideshow);

            // Slideshow Indicators
            let slideshowIndicators = document.createElement('div');

            slideshowIndicators.classList.add('carousel-indicators');

            slideshow.appendChild(slideshowIndicators);

            // Slideshow Inner
            let slideshowInner = document.createElement('div');

            slideshowInner.classList.add('carousel-inner');

            slideshow.appendChild(slideshowInner);

            // Slide Container
            let idx = 0
            _.each(project.slideshow, function(slide) {
                // Slide
                let slideContainer = document.createElement('div');

                slideContainer.classList.add('carousel-item');
                if (idx === 0) { slideContainer.classList.add('active'); }

                let slideImageContainer = document.createElement('div');

                slideImageContainer.classList.add('ratio');
                slideImageContainer.classList.add('ratio-16x9');

                slideContainer.appendChild(slideImageContainer);

                let slideImage = document.createElement('img');

                if (slideStaticImages[slide.img]) {
                    slideImage.setAttribute('src', globUrl(slideStaticImages, slide.img));
                } else {
                    slideImage.setAttribute('src', globUrl(projectStaticImages, "project-default"));
                }
                slideImage.setAttribute('alt', slide.image);
                slideImage.classList.add('d-block');
                slideImage.classList.add('w-100');
                slideImage.classList.add('img-thumbnail');

                slideImageContainer.appendChild(slideImage)

                // Caption
                if (slide.caption) {
                    let slideCaption = document.createElement('div');
                    slideCaption.classList.add('carousel-caption');
                    slideCaption.classList.add('d-none');
                    slideCaption.classList.add('d-md-block');
                    slideCaption.classList.add('bg-light');
                    slideCaption.classList.add('bg-opacity-75');
                    slideCaption.classList.add('rounded-3')
                    slideCaption.classList.add('p-3')
                    slideCaption.innerHTML = `<p class="fw-bolder">${slide.caption}</p>`

                    slideContainer.appendChild(slideCaption);
                }

                slideshowInner.appendChild(slideContainer);

                // Indicator
                let slideIndicator = document.createElement('button');

                slideIndicator.setAttribute('type', 'button');
                slideIndicator.setAttribute('data-bs-target', `#slideshow-${project.id}`);
                slideIndicator.setAttribute('data-bs-slide-to', `${idx}`);
                if (idx === 0) { slideIndicator.classList.add('active'); }

                slideshowIndicators.appendChild(slideIndicator);

                idx++;
            });

            // Slideshow Buttons
            let slideshowBtnPrevious = document.createElement('button');

            slideshowBtnPrevious.setAttribute('type', 'button');
            slideshowBtnPrevious.setAttribute('data-bs-target', `#slideshow-${project.id}`);
            slideshowBtnPrevious.setAttribute('data-bs-slide', 'prev');
            slideshowBtnPrevious.classList.add('carousel-control-prev');
            slideshowBtnPrevious.innerHTML = '<i class="fa-solid fa-circle-chevron-left fa-2x text-light"></i><span class="visually-hidden">Previous</span>';

            new bsn.Button(slideshowBtnPrevious);
            slideshow.appendChild(slideshowBtnPrevious);

            let slideshowBtnNext = document.createElement('button');

            slideshowBtnNext.setAttribute('type', 'button');
            slideshowBtnNext.setAttribute('data-bs-target', `#slideshow-${project.id}`);
            slideshowBtnNext.setAttribute('data-bs-slide', 'next');
            slideshowBtnNext.classList.add('carousel-control-next');
            slideshowBtnNext.innerHTML = '<i class="fa-solid fa-circle-chevron-right fa-2x text-light"></i></span><span class="visually-hidden">Next</span>';

            new bsn.Button(slideshowBtnNext);
            slideshow.appendChild(slideshowBtnNext);


            new bsn.Carousel(slideshow);
        }

        tabPanes.appendChild(tabPane);

        /*** DROPDOWN CREATION ***/
        let projects = document.getElementById('projects');

        let dropdown_item = document.createElement('a');
        dropdown_item.setAttribute('id', 'p-' + project.id + '-tab');

        dropdown_item.setAttribute('data-bs-target', '#' + tabPane.getAttribute('id'));
        dropdown_item.setAttribute('data-bs-toggle', 'tab');
        dropdown_item.setAttribute('data-bs-height', 'true');
        dropdown_item.setAttribute('aria-controls', tabPane.getAttribute('id'));
        dropdown_item.setAttribute('aria-selected', 'false');
        dropdown_item.setAttribute('role', 'button');
        dropdown_item.classList.add('dropdown-item');
        dropdown_item.classList.add('fs-5');
        dropdown_item.innerHTML = project.fa_icon + "&nbsp;" + project.shortname;

        if (project.id !== "sarkamist-github-io") projects.appendChild(dropdown_item);
        new bsn.Tab(dropdown_item);

        /*** HOME QUICK CARD CREATION ***/
        let quick_cards = document.getElementById('quick-cards');

        // PROJECT COLUMN
        let column = document.createElement('div');

        column.classList.add('col')

        // CARD
        let card = document.createElement('div')

        card.setAttribute('id', 'home-' + project.id + '-card');
        card.classList.add('card');

        column.appendChild(card);

        // CARD IMAGE CONTAINER
        let cardImageContainer = document.createElement('div');

        cardImageContainer.classList.add('ratio');
        cardImageContainer.classList.add('ratio-16x9');

        card.appendChild(cardImageContainer);

        // CARD IMAGE
        let cardImage = createProjectMedia(projectStaticImages, project.img, project.shortname);

        cardImage.classList.add('card-img-top');

        cardImageContainer.appendChild(cardImage);

        // CARD BODY
        let cardBody = document.createElement('div');

        cardBody.classList.add('card-body');

        card.appendChild(cardBody);

        // CARD NAME
        let cardName = document.createElement('h5');

        cardName.classList.add('card-title');
        cardName.classList.add('fw-bolder');
        cardName.innerHTML = project.shortname;

        cardBody.appendChild(cardName);

        // CARD DESCRIPTION
        let cardDescription = document.createElement('p');
        cardDescription.classList.add('card-text');
        cardDescription.innerHTML = project.brief;

        cardBody.appendChild(cardDescription);

        // CARD FOOTER
        let cardFooter = document.createElement('div');

        cardFooter.classList.add('card-footer');
        cardFooter.classList.add('d-flex');
        cardFooter.classList.add('justify-content-between');

        card.appendChild(cardFooter);

        // CARD BUTTON COLUMN
        let cardButtonColumn = document.createElement('div');

        cardButtonColumn.classList.add('col-10');
        cardButtonColumn.classList.add('col-md-10');

        cardFooter.appendChild(cardButtonColumn);

        // CARD BUTTON
        let cardButton = document.createElement('a');

        cardButton.setAttribute('id', 'home-' + project.id + '-button');

        cardButton.classList.add('btn');
        cardButton.classList.add('btn-lg');
        cardButton.classList.add('btn-dark');
        cardButton.classList.add('f-inconsolata');
        cardButton.classList.add('stretched-link')
        cardButton.setAttribute('href', '#' + dropdown_item.getAttribute('id'));
        cardButton.setAttribute('role', 'button');
        cardButton.innerHTML = "See more";

        cardButton.addEventListener('click', function(e) {
            e.preventDefault();
            let href = e.target.getAttribute('href');
            if (href && href.startsWith('#') && href.length > 1) {
                let target = document.getElementById(href.substring(1));
                if (bsn.Tab.getInstance(target)) {
                    bsn.Tab.getInstance(target).show();
                }
            }
        });

        cardButtonColumn.appendChild(cardButton);

        // CARD ICON COLUMN
        let cardIconColumn = document.createElement('div');

        cardIconColumn.classList.add('d-flex');
        cardIconColumn.classList.add('align-items-center');
        cardIconColumn.innerHTML = "<span class='card-icon'>" + project.fa_icon + "</span>";

        cardFooter.appendChild(cardIconColumn);

        if (project.id !== "sarkamist-github-io") quick_cards.appendChild(column);
    });

    //INIT CALLS
    handleHashChange()
    iCustomApplyInlines(document)

    //EVENT LISTENERS
    document.querySelectorAll('a[data-bs-toggle="tab"]').forEach(tab => {
        tab.addEventListener('shown.bs.tab', e => {
            let targetId = e.target.getAttribute("data-bs-target")

            if (targetId === "#home") {
                history.pushState(null, "", window.location.pathname)
            } else {
                history.pushState(null, "", targetId);
            }

            document.querySelectorAll('.tab-pane video').forEach(video => {
                if (video.closest('.tab-pane').classList.contains('active')) {
                    video.play().catch(() => {});
                } else {
                    video.pause();
                }
            });
        });
    });

    window.addEventListener('popstate', () => {
        handleHashChange()
    });

    new MutationObserver(muts => {
        for (const m of muts) {
            m.addedNodes.forEach(n => n.nodeType === 1 && iCustomApplyInlines(n))
        }
    }).observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

function handleHashChange() {
    const hash = window.location.hash.replace('#', '');
    const targetId = hash || 'home';
    const targetTab = document.querySelector(`a.nav-link[data-bs-target='#${targetId}'], a.dropdown-item[data-bs-target='#${targetId}']`);
    if (targetTab && bsn.Tab.getInstance(targetTab)) {
        bsn.Tab.getInstance(targetTab).show();
    }
}

function iCustomApplyInlines(root) {
    root.querySelectorAll('i.i-custom:not(.svg-inline--fa)').forEach(iCustom => {
        iCustom.classList.add('svg-inline--fa');
    });
}

function globEntry(collection, name, fallback = "project-default") {
    return collection[name] || collection[fallback];
}

function globUrl(collection, name, fallback = "project-default") {
    let entry = globEntry(collection, name, fallback);
    return entry ? Object.values(entry)[0] : "";
}

const VIDEO_EXTENSIONS = ['mp4', 'webm'];

function createProjectMedia(collection, name, altText) {
    let entry = globEntry(collection, name);
    let extensions = entry ? Object.keys(entry) : [];
    let videoExt = extensions.find(ext => VIDEO_EXTENSIONS.includes(ext));

    if (!videoExt) {
        let image = document.createElement('img');
        image.setAttribute('src', entry ? entry[extensions[0]] : "");
        image.setAttribute('alt', altText);
        return image;
    }

    let video = document.createElement('video');
    video.muted = true; // property, not just attribute: required for JS-created elements to satisfy autoplay policy
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('aria-label', altText);

    let posterExt = extensions.find(ext => !VIDEO_EXTENSIONS.includes(ext));
    if (posterExt) video.setAttribute('poster', entry[posterExt]);

    video.src = entry[videoExt];
    return video;
}

